/**
 * O status que cada coluna do Kanban recebe quando a equipe arrasta um cartão para ela
 * (07/10/2026). "Em andamento" junta vários status; arrastado, o chamado vai para Em
 * Desenvolvimento — os outros continuam na etiqueta do cartão.
 */
export const STATUS_DA_COLUNA: Record<string, { id: number; nome: string }> = {
  Solicitados: { id: 1, nome: "Solicitado" },
  "Em andamento": { id: 5, nome: "Em Desenvolvimento" },
  Concluídos: { id: 6, nome: "Concluído" },
};
